import { SHOPIFY_STORE_DOMAIN, SHOPIFY_STOREFRONT_API_TOKEN } from '@portal/config/base';
import type { StoreCode } from 'schema/storeCode';
import { deleteCustomerAddressMutation } from '../mutations/deleteCustomerAddress';
import { getCustomerData } from '../queries/getCustomerData';
import type { CustomerAddressDeleteResponse, GetCustomerDataResponse } from '../types';
import { shopifyFetch } from '../utils';

export const getCustomerDetails = async (
  storeCode: StoreCode,
  customerAccessToken: string
): Promise<GetCustomerDataResponse> => {
  const res = await shopifyFetch<any>({
    query: getCustomerData,
    shopifyDomain: SHOPIFY_STORE_DOMAIN[storeCode],
    accessToken: SHOPIFY_STOREFRONT_API_TOKEN[storeCode],
    variables: {
      customerAccessToken
    }
  });

  return res.body.data;
};

export const deleteCustomerAddress = async (
  storeCode: StoreCode,
  customerAccessToken: string,
  id: string
): Promise<CustomerAddressDeleteResponse> => {
  const res = await shopifyFetch<any>({
    query: deleteCustomerAddressMutation,
    shopifyDomain: SHOPIFY_STORE_DOMAIN[storeCode],
    accessToken: SHOPIFY_STOREFRONT_API_TOKEN[storeCode],
    variables: {
      customerAccessToken,
      id
    }
  });

  return res.body.data.customerAddressDelete;
};
